/**
 * Thin wrapper over the vanilla-cookieconsent instance created in
 * plugins/cookieconsent.client.ts. Client-only: on the server every call is a
 * no-op and `acceptedCategory()` reports false, so SSR never renders anything
 * that depends on a consent the browser hasn't given yet.
 */
export function useCookieConsent() {
  const load = async () => await import('vanilla-cookieconsent')

  /** Reopens the preferences modal (footer "Nastavení cookies" link). */
  const showPreferences = async () => {
    if (import.meta.server) return
    ;(await load()).showPreferences()
  }

  /** Switches the bar/modal language, e.g. after the user changes the locale. */
  const setLanguage = async (code: string) => {
    if (import.meta.server) return
    await (await load()).setLanguage(code)
  }

  /** Whether the visitor consented to a category. Always false during SSR. */
  const acceptedCategory = async (category: 'necessary' | 'analytics' | 'marketing') => {
    if (import.meta.server) return false
    return (await load()).acceptedCategory(category)
  }

  return { showPreferences, setLanguage, acceptedCategory }
}
